(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var announcement = header.querySelector('.announcement-bar');
  var root = document.documentElement;

  function setAnnouncementHeight() {
    var h = announcement ? announcement.offsetHeight : 0;
    root.style.setProperty('--announcement-h', h + 'px');
    return h;
  }

  var annHeight = setAnnouncementHeight();
  window.addEventListener('resize', setAnnouncementHeight, { passive: true });

  function toggleStuck() {
    annHeight = announcement ? announcement.offsetHeight : 0;
    header.classList.toggle('is-stuck', window.scrollY > annHeight);
  }

  toggleStuck();
  window.addEventListener('scroll', toggleStuck, { passive: true });
})();
